// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1_b3Q","alertIcon":"ConfirmModal_alertIcon__y78UM"};